<script lang="ts">
</script>

<div data-testid="investorflow-success">
  <div>Loading...</div>
</div>

<style>
  div {
    align-self: center;
    font-size: 3rem;
  }
</style>
